import { Box, Button, DialogContent } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { setOpenModal } from "../../store/controlPanelSlice";
import { setOpenModal as setOpenModalAuth } from "../../../Auth/store/authSlice";
import { useDispatch } from "react-redux";
import "./InfoAndSupport.css";
import config from "../../../../constants/config.json";
const InfoAndSupport = () => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const versionOnly = config.VERSION;
        return (
        <>
            <DialogContent>
                <Box className="info-and-support-container">
                    <div className="support-container-1">
                        <span className="support-titles">
                            {t("assistance")}
                        </span>
                        <div className="support-container-buttons">
                            <div>
                                <Button style={{
                                    display: "flex",
                                    padding: "1rem",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: "0.5625rem",
                                    borderRadius: "1rem",
                                    border: "1px solid #CDD5DF",
                                    background: "#F8FAFC"
                                }} onClick={() => {dispatch(setOpenModalAuth({
                                    name: "welcome",
                                    payload: {
                                    source: "info_support",
                                    }
                                })) ; dispatch(setOpenModal(null))}}>

                                    <span className="material-symbols-outlined support-icon">
                                        book_2
                                    </span>
                                    <span className="support-button-text">
                                        {t("view_tuto")}
                                    </span>
                                </Button>
                            </div>
                            <div>
                                <Button style={{
                                    display: "flex",
                                    padding: "1rem",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: "0.5625rem",
                                    borderRadius: "1rem",
                                    border: "1px solid #CDD5DF",
                                    background: "#F8FAFC"
                                }} onClick={() => dispatch(setOpenModal("support"))}>

                                    <span className="material-symbols-outlined support-icon">
                                        error
                                    </span>
                                    <span className="support-button-text">
                                        {t("report_problem")}
                                    </span>
                                </Button>
                            </div>
                        </div>
                    </div>
                        <div className="support-container-2">
                            <span className="support-titles">
                                {t("about_aifel")}
                            </span>
                            <span className="support-text-1">
                                {t("about_aifel_text")}
                            </span>
                            <span className="support-text-2"

                                onClick={() => dispatch(setOpenModal("release_note"))}
                                style={{ cursor: "pointer" }}>
                                © 2025 Aifel.eu - Version {versionOnly}
                                <span class="material-symbols-outlined legal-icon">
                                    info
                                </span>
                            </span>
                        </div>
                    <div className="support-container-3">
                        <span className="support-titles">
                            {t("legal_mention")}
                        </span>
                        <div className="legal-container">
                            <span className="legal-text">
                                {t("privacy_policy")}
                            </span>
                            <a href="https://aifel.eu/politique-de-confidentialite/" target="_blank" rel="noopener noreferrer" >
                                <span className="material-symbols-outlined legal-icon">
                                    open_in_new
                                </span>
                            </a>
                        </div>
                        <div className="legal-container" >
                            <span className="legal-text">
                                {t("general_conditions")}
                            </span>
                            <a href="https://aifel.eu/conditions-generales/" target="_blank" rel="noopener noreferrer">
                                <span className="material-symbols-outlined legal-icon">
                                    open_in_new
                                </span>
                            </a>
                        </div>
                    </div>
                </Box>
            </DialogContent>
        </>
    )
}

export default InfoAndSupport